<template>
    <nav class="navbar has-shadow">
        <div class="container is-fluid">
            <div class="navbar-menu" id="navMenu">
                <div class="navbar-start">
                    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <app-breadcrumbs container="ul">
                            <li slot-scope="{to, label, utils}">
                                <router-link :to="to" class="your-custom-class" exact :itemprop="utils && utils.itemprop">
                                    {{label}}
                                </router-link>
                            </li>
                            <a slot="current" slot-scope="{label}" class="is-active">
                                {{label}}
                            </a>
                        </app-breadcrumbs>
                    </nav>
                </div>

                <div class="navbar-end">
                    <b-dropdown position="is-bottom-left">
                        <a class="navbar-item" slot="trigger">
                            <span style="padding-right: 0.75rem;">{{ $store.getters.name }}</span>
                            <i class="fa fa-angle-down"></i>
                        </a>

                        <b-dropdown-item has-link>
                            <a class="navbar-item" href="/subscription">
                                Abonnement
                            </a>
                        </b-dropdown-item>

                        <b-dropdown-item has-link>
                            <a class="navbar-item" onclick="event.preventDefault();document.getElementById('logout-form').submit();">
                                Se déconnecter
                            </a>
                            <form id="logout-form" action="/logout" method="POST"
                                  style="display: none;">
                                <input type="hidden" name="_token" :value="csrf">
                            </form>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        data() {
            return {
                csrf: '',
            }
        },

        methods: {
            logout() {
                axios.post('/logout')
                     .then( response => {
                        window.location.replace('/');                    
                });
            }
        },

        created() {
            this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
        }
    }
</script>

<style>

    .breadcrumb ul, .breadcrumb li {
        height: 100%;
    }
    
    .breadcrumb a {
        color: #363636;
        padding: 0.5rem;
    }

    .breadcrumb a:hover {
        color: #365F79;
    }
</style>